import { render, staticRenderFns } from "./weaponEnchantments.vue?vue&type=template&id=64a9b216&scoped=true&"
import script from "./weaponEnchantments.vue?vue&type=script&lang=js&"
export * from "./weaponEnchantments.vue?vue&type=script&lang=js&"
import style0 from "./weaponEnchantments.vue?vue&type=style&index=0&id=64a9b216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a9b216",
  null
  
)

export default component.exports